import "../../assets/css/menu.css"
import "../../assets/css/responsive.css";
import MobileHeader from "./MobileHedaer";
// import menimg from '../../assets/images/megamenu-banner7.jpg';
// import logo from "../../assets/images/logo.webp";

function Navigation() {
  return (
    <>
      <header className="header animated d-flex align-items-center header-1">
        <div className="container">
          <div className="row">
            {/*Mobile Icons*/}
            <div className="col-4 col-sm-4 col-md-4 d-block d-lg-none mobile-icons">
              {/*Mobile Toggle*/}
              <button type="button" className="btn--link site-header__menu js-mobile-nav-toggle mobile-nav--open" >
              <MobileHeader/>
              </button>
              {/*End Mobile Toggle*/}
              {/*Search*/}
              {/* <div className="site-search iconset"  style={{ marginLeft: "23px", marginTop: "11px"}}>
                <i className="icon anm bi bi-search" />
              </div> */}
              {/*End Search*/}
            </div>
            {/*Mobile Icons*/}
            {/*Desktop Logo*/}
            <div className="logo col-4 col-sm-4 col-md-4 col-lg-2 align-self-center">
              <a href="/">
                <img
                  src=""
                  alt="logo"
                  title="logo"
                />
              </a>
            </div>
            {/*End Desktop Logo*/}
            <div className="col-1 col-sm-1 col-md-1 col-lg-8 align-self-center d-menu-col">
              {/*Desktop Menu*/}
              <nav className="grid__item" id="AccessibleNav">
                <ul id="siteNav" className="site-nav medium center hidearrow">
            
                  <li className="lvl1 parent megamenu">
                    <a href="/productList">
                       Floor Covering <i className="anm anm-angle-down-l" />
                    </a>
                    <div className="megamenu style4 row">
                      <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                          <li className="lvl-2">  <a href="/productList" className="site-nav lvl-2" > Bath Mat </a> </li>
                          <li className="lvl-2">  <a href="/productList" className="site-nav lvl-2" > Shower Mat </a> </li>
                          
                          </ul>
                      </div>
                      <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                          <li className="lvl-2">  <a href="/productList" className="site-nav lvl-2" > Outdoor Mat </a> </li>
                           <li className="lvl-2">  <a href="/productList" className="site-nav lvl-2" > Kitchen Mat </a> </li>
                          </ul>
                      </div>
                      <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                          <li className="lvl-2">  <a href="/productList" className="site-nav lvl-2" > Floor Mat </a> </li>
                           <li className="lvl-2">  <a href="/productList" className="site-nav lvl-2" > Carpet & Rug </a> </li>
                          
                          </ul>
                      </div>
                       <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                         <li className="lvl-2">  <a href="/productList" className="site-nav lvl-2" > Yoga Mat </a> </li>
                          </ul>
                      </div>
                    </div>
                  </li>

                   <li className="lvl1 parent dropdown">
                    <a href="/tablewear">
                     TableWear <i className="anm anm-angle-down-l" />
                    </a>
                    <ul className="dropdown">
                      <li>
                        <a href="/tablewear" className="site-nav">
                          Table Mat
                        </a>
                      </li>
                      <li>
                        <a href="/tablewear" className="site-nav">
                          Table Runner
                        </a>
                      </li>
                      <li>
                        <a href="/tablewear" className="site-nav">
                         Table Cover
                        </a>
                      </li>
                      <li>
                        <a href="/tablewear" className="site-nav">
                          Table Accessories
                        </a>
                      </li>
                  
                    </ul>
                  </li>

                  <li className="lvl1 parent megamenu">
                    <a href="/bathline">
                       Bath Linen <i className="anm anm-angle-down-l" />
                    </a>
                    <div className="megamenu style4 row">
                      <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                          <li className="lvl-2">  <a href="/bathline" className="site-nav lvl-2" > Bath Towel </a> </li>
                          <li className="lvl-2">  <a href="/bathline" className="site-nav lvl-2" > Medium Towel </a> </li>
                          
                          </ul>
                      </div>
                      <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                          <li className="lvl-2">  <a href="/bathline" className="site-nav lvl-2" > Hand Towel </a> </li>
                           <li className="lvl-2">  <a href="/bathline" className="site-nav lvl-2" > Face Towel </a> </li>
                          </ul>
                      </div>
                      <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                          <li className="lvl-2">  <a href="/bathline" className="site-nav lvl-2" > Wash Basin Towel </a> </li>
                           <li className="lvl-2">  <a href="/bathline" className="site-nav lvl-2" > Bath Gown </a> </li>
                          
                          </ul>
                      </div>
                       <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                         <li className="lvl-2">  <a href="/bathline" className="site-nav lvl-2" > Towel Sets </a> </li>
                          <li className="lvl-2">  <a href="/bathline" className="site-nav lvl-2" > Kids Towel </a> </li>
                          </ul>
                      </div>
                    </div>
                  </li>

                  <li className="lvl1 parent dropdown">
                    <a href="#">
                      Bed Linen <i className="anm anm-angle-down-l" />
                    </a>
                    <ul className="dropdown">
                      <li>
                        <a href="blog-left-sidebar.html" className="site-nav">
                         Bed Sheet
                        </a>
                      </li>
                      <li>
                        <a href="blog-right-sidebar.html" className="site-nav">
                          Bed Covers
                        </a>
                      </li>
                      <li>
                        <a href="blog-fullwidth.html" className="site-nav">
                          Dohar 
                        </a>
                      </li>
                      <li>
                        <a href="blog-2columns.html" className="site-nav">
                          Comforter
                        </a>
                      </li>
                      <li>
                        <a href="blog-3columns.html" className="site-nav">
                         Bed in a Bag
                        </a>
                      </li>
                      <li>
                        <a href="blog-4columns.html" className="site-nav">
                         Pillows
                        </a>
                      </li>
                      
                    </ul>
                  </li>

                   <li className="lvl1 parent dropdown">
                    <a href="/homedecor">
                     Home Decor <i className="anm anm-angle-down-l" />
                    </a>
                    <ul className="dropdown">
                      <li>
                        <a href="/homedecor" className="site-nav">
                          Diwan Sets
                        </a>
                      </li>
                      <li>
                        <a href="/homedecor" className="site-nav">
                         Fancy Cushion and Bolster
                        </a>
                      </li>
                      <li>
                        <a href="/homedecor" className="site-nav">
                          Cushion And Bolster Covers
                        </a>
                      </li>
                      <li>
                        <a href="/homedecor" className="site-nav">
                         Throws
                        </a>
                      </li>
                      <li>
                        <a href="/homedecor" className="site-nav">
                          Sofa Cover
                        </a>
                      </li>
                      <li>
                        <a href="/homedecor" className="site-nav">
                          Sofa Seatback
                        </a>
                      </li>
                      <li>
                        <a href="/homedecor" className="site-nav">
                          Sofa Panel
                        </a>
                      </li>
                    </ul>
                  </li>

                    <li className="lvl1 parent megamenu">
                    <a href="/dustbin">
                       Home Accessories <i className="anm anm-angle-down-l" />
                    </a>
                    <div className="megamenu style4 row">
                      <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                          <li className="lvl-2">  <a href="/dustbin" className="site-nav lvl-2" > Dustbin </a> </li>
                          <li className="lvl-2">  <a href="/dustbin" className="site-nav lvl-2" > Laundry basket </a> </li>
                           <li className="lvl-2">  <a href="/dustbin" className="site-nav lvl-2" > Trays </a> </li>
                           <li className="lvl-2">  <a href="/dustbin" className="site-nav lvl-2" >  Bath Accessories </a> </li>
                           <li className="lvl-2">  <a href="/dustbin" className="site-nav lvl-2" >  Pouffe </a> </li>
                          
                          </ul>
                      </div>
                      <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                          <li className="lvl-2">  <a href="/dustbin" className="site-nav lvl-2" > Tissue Box </a> </li>
                           <li className="lvl-2">  <a href="/dustbin" className="site-nav lvl-2" > Service Trolley </a> </li>
                           <li className="lvl-2">  <a href="/dustbin" className="site-nav lvl-2" > Apron</a> </li>
                            <li className="lvl-2">  <a href="/dustbin" className="site-nav lvl-2" > Washing Machine Cover </a> </li>
                            <li className="lvl-2">  <a href="/dustbin" className="site-nav lvl-2" > Dish Mat </a> </li>

                          </ul>
                      </div>
                      <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                          <li className="lvl-2">  <a href="/dustbin" className="site-nav lvl-2" > Fridge Top </a> </li>
                            <li className="lvl-2">  <a href="/dustbin" className="site-nav lvl-2" > AC Curtain </a> </li>
                            <li className="lvl-2">  <a href="/dustbin" className="site-nav lvl-2" > Bed Server </a> </li>
                           <li className="lvl-2">  <a href="/dustbin" className="site-nav lvl-2" > Shelf Liner </a> </li>
                             <li className="lvl-2">  <a href="/dustbin" className="site-nav lvl-2" > Napkin</a> </li>
                          </ul>
                      </div>
                       <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                       
                          <li className="lvl-2">  <a href="/dustbin" className="site-nav lvl-2" > Glove </a> </li>
                          <li className="lvl-2">  <a href="/dustbin" className="site-nav lvl-2" > Coaster </a> </li>
                          <li className="lvl-2">  <a href="/dustbin" className="site-nav lvl-2" > Oven Top </a> </li>

                          </ul>
                      </div>
                    </div>
                  </li>
                </ul>
              </nav>
              {/*End Desktop Menu*/}
            </div>
            <div className="col-4 col-sm-4 col-md-4 col-lg-2 align-self-center icons-col text-right">
              {/*Search*/}
              {/* <div className="site-search iconset">
                <i className="icon anm bi bi-search" />
              </div> */}
              {/*End Setting Dropdown*/}
              {/*Wishlist*/}
              <div className="wishlist-link iconset">
                <i className="icon anm bi bi-heart" />
                <span className="wishlist-count">0</span>
              </div>
              {/*End Wishlist*/}
              {/*Minicart Dropdown*/}
              <div className="wishlist-link iconset">
                <a
                  href="/checkout/cart"
                  className="site-header__cart btn-minicart"
                  data-toggle="modal"
                  data-target="#minicart-drawer"
                 >
                  <i className="icon anm bi bi-bag" />
                  <span className="site-cart-count">2</span>
                </a>
              </div>
              {/*End Minicart Dropdown*/}
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
export default Navigation;
